"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePreventScroll = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var isomorphic_layout_effect_1 = require("../../libs/isomorphic-layout-effect");
var ScrollLocker = tslib_1.__importStar(require("../../libs/scroll-locker"));
/**
 * Raact hook that prevents content from scrolling on an element.
 *
 * @example
 * const Modal: FC<ModalProps> = (props) => {
 *   const { visible } = props;
 *   const containerRef = useRef(document.documentElement);
 *
 *   usePreventScroll({ enabled: visible, containerRef });
 *
 *   ...
 * }
 */
function usePreventScroll(options) {
    var enabled = options.enabled, containerRef = options.containerRef;
    var elementRef = (0, react_1.useRef)(null);
    var lockedRef = (0, react_1.useRef)(false);
    (0, isomorphic_layout_effect_1.useIsomorphicLayoutEffect)(function () {
        var container = containerRef ? containerRef.current : null;
        if (elementRef.current === container) {
            return;
        }
        // We handle the case when the reference to the element has changed,
        // and the current one has a lock enabled
        if (enabled && lockedRef.current) {
            ScrollLocker.unlock(elementRef.current);
            ScrollLocker.lock(container);
        }
        elementRef.current = container;
    });
    (0, isomorphic_layout_effect_1.useIsomorphicLayoutEffect)(function () {
        if (!enabled) {
            return;
        }
        lockedRef.current = true;
        ScrollLocker.lock(elementRef.current);
        return function () {
            lockedRef.current = false;
            ScrollLocker.unlock(elementRef.current);
        };
    }, [enabled]);
}
exports.usePreventScroll = usePreventScroll;
